import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { CreateNoteForm } from '@components/Notes/CreateForm';
import { PageTitle } from '@components/PageTitle';
import { queryKeys } from '@constants/queryKeys.constant';
import { ENoteOwnerType } from '@enums/note.enum';
import { updateProviderCounts } from '@helpers/queryCache/updateTabCounts.helper';

export const Route = createFileRoute(
  '/_layout/(private)/providers/$id/notes/create',
)({
  component: ProviderNoteCreate,
});

function ProviderNoteCreate() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <>
      <PageTitle
        hasBackButton
        params={{ id }}
        title="Create note"
        to="/providers/$id"
      />
      <CreateNoteForm
        notePayload={{ ownerType: ENoteOwnerType.Provider, providerId: id }}
        onCancel={() => navigate({ params: { id }, to: '/providers/$id' })}
        onCreate={() =>
          updateProviderCounts({
            delta: 1,
            field: 'notes',
            providerId: id,
            queryClient,
          })
        }
        onSuccess={() =>
          navigate({ params: { id }, replace: true, to: '/providers/$id' })
        }
        queryKeyToInvalidate={queryKeys.providers.notes(id)}
      />
    </>
  );
}
